import { Component } from '@angular/core';

import { EditAddressComponent } from './edit-address.component';

@Component({
  selector: 'eid-edit-address-desktop',
  templateUrl: './edit-address.desktop.component.html',
  styleUrls: ['./edit-address.desktop.component.scss']
})
export class EditAddressDesktopComponent extends EditAddressComponent {}
